// Zentrale Stammdaten fuer Impressum und Datenschutzerklaerung.
//
// Art. 3 Abs. 1 lit. s UWG verlangt fuer den elektronischen Geschaeftsverkehr
// neben Name und E-Mail auch eine geografische Adresse. Auf die Postadresse
// wird hier auf ausdruecklichen Entscheid des Betreibers verzichtet; das
// Impressum fuehrt bewusst nur Name und E-Mail.

export const COMPANY_NAME = "Imkerei Bühler Mettmenstetten (IBM Honig)";
export const CONTACT_EMAIL = "ibm.honig.bestellen@gmail.com";
export const LEGAL_LAST_UPDATED = "2. August 2026";
